import { createMuiTheme } from '@material-ui/core';

export default createMuiTheme({
  palette: {
    action: {
      disabled: 'transparent',
      disabledBackground: 'transparent',
    },
    primary: {
      main: '#ff5c5c',
    },
  },
  shadows: [
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
  ],
});
